import { useBreakpoints } from "@narmi/design_system";
import { useDashboardLayoutRedesignEnabled } from "byzantine";
import useIsMarketingBannersEnabled from "../MarketingImage/hooks";
import useWelcomeOffer from "./useWelcomeOffer";

const useIsMarketingCardVisible = (): boolean => {
  const isMarketingBannersEnabled = useIsMarketingBannersEnabled();
  const welcomeOffer = useWelcomeOffer();
  const { m } = useBreakpoints();
  const isDashboardLayoutRedesignEnabled = useDashboardLayoutRedesignEnabled();

  const isEnabled = Boolean(welcomeOffer) || isMarketingBannersEnabled;

  // In the redesigned layout the card only shows on small screens.
  return isEnabled && (!isDashboardLayoutRedesignEnabled || !m);
};

export default useIsMarketingCardVisible;
